import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CartStoreModel } from './CartStore';
import { CheckoutStoreModel } from './CheckoutStore';
import { CmsDialogStoreModel } from './CmsDialogStore';
import { CmsUkCouponStore } from './CmsUkCouponStore';
import { CommentOptsStoreModel } from './CommentOptsStore';
import { CountryStoreModel } from './CountryStore';
import { DpStoreModel } from './DpStore';
import { LoginStoreModel } from './loginStore';
import { RecommendStoreModel } from './RecommendStore';
import { SearchForAddonStoreModel } from './SearchForAddonStore';
import { ServiceListStoreModel } from './ServiceListStore';
import { CartNumStore } from './CartNumStore';
import { UserInfoStore } from './UserInfoStore';

/**
 * A RootStore model.
 */
export const RootStoreModel = types.model('RootStore').props({
  cmsDialogStore: types.optional(CmsDialogStoreModel, {}),
  commentOpstsStore: types.optional(CommentOptsStoreModel, {}),
  searchForAddonStore: types.optional(SearchForAddonStoreModel, {}),
  cmsUkCouponStore: types.optional(CmsUkCouponStore, {}),
  checkoutStore: types.optional(CheckoutStoreModel, {}),
  loginStore: types.optional(LoginStoreModel, {}),
  cartStore: types.optional(CartStoreModel, {}),
  dpStore: types.optional(DpStoreModel, {}),
  countryStore: types.optional(CountryStoreModel, {}),
  recommendStore: types.optional(RecommendStoreModel, {}),
  serviceListStore: types.optional(ServiceListStoreModel, {
    mainSkuId: '',
    selectedListAll: {},
  }),
  cartNumStore: types.optional(CartNumStore, {}),
  userInfoStore: types.optional(UserInfoStore, {}),
});

/**
 * The RootStore instance.
 */
export type RootStore = Instance<typeof RootStoreModel>;

/**
 * The data of a RootStore.
 */
export type RootStoreSnapshot = SnapshotOut<typeof RootStoreModel>;
